import { toCronObject, patchCronString, CronString } from "../cronUtils";

import { timeOfDayOptions, TimeOfDayOption } from "./dataModel";

/* CronString <--> Selected option */

export function toTimeOfDayOption(cronString: CronString) {
  const { hour, minute } = toCronObject(cronString);

  return timeOfDayOptions.find(
    (option) =>
      (hour === "*" || hour === String(option.start.hour)) &&
      (minute === "*" || minute === String(option.start.minute))
  );
}

export function applyTimeOfDayOptionToCronString(
  cronString: CronString,
  option: TimeOfDayOption
): CronString {
  return patchCronString(cronString)({
    hour: `${option.start.hour}`,
    minute: `${option.start.minute}`,
  });
}
